const locale: Locale = {
  ko: {
    btn: '청원 작성 요령 안내',

    mainTitle: '지스트 청원, 이렇게 등록하세요!',

    title1: '기존 청원 확인',
    contents1:
      '새 청원글 작성 전 유사한 내용의 청원이 진행 중인지 먼저 확인해주세요. \
      새 청원글을 작성하기보다 유사한 기존 청원에 동의하시면 GIST 구성원의 뜻을 모으는데 도움이 됩니다.',
    title2: '제목 입력',
    contents2:
      '청원 내용을 대표하는 제목을 입력해주세요. 제목의 내용은 100자 이하로 제한합니다.',
    title3: '카테고리 선택',
    contents3:
      '청원 내용과 관련된 분야를 선택해주세요. 참여자들이 청원 목록 내 카테고리 필터를 통해 접근할 수 있습니다.',
    title4: '내용 입력',
    contents4:
      '사람들이 쉽게 읽고 이해할 수 있는 내용으로 작성해주시면 됩니다. 글자 수는 10000자 이하로 제한합니다.',
    title5: '검토 및 게시',
    contents5:
      '한번 작성된 청원은 수정 및 삭제가 불가능합니다. 최초 청원 취지와 다른 내용으로 변경되는 \
      것을 방지하여 청원 참여자의 의견을 보호하기 위한 조치이니 신중하게 게시해주시기 바랍니다.',
  },
  en: {
    btn: 'Guide to Write a Petition',

    mainTitle: 'Follow These Steps!',

    title1: 'Check Existing Petitions',
    contents1:
      'Before writing the petition, please check if the petition with similar content is already in progress.\
       Rather than writing a new petition, \
       agreeing to the similar petition will help GIST members gather their opinion.',
    title2: 'Fill in Title',
    contents2:
      'Enter a title that represents the content of the petition. \
      The length of title is limited to 100 characters or less.',
    title3: 'Select Category',
    contents3:
      'Please select a category related to the content of the petition. \
      Users can view it through category filter in the petition list.',
    title4: 'Fill in Description',
    contents4:
      'Write description that people can easily read and understand. \
      The length of description is limited to 10000 characters or less.',
    title5: 'Review and Submit',
    contents5:
      'Once a petition has been written, it cannot be modified or deleted. \
      Please post it carefully because it is a measure to protect the opinions \
      of the supporters by preventing changes to the original purpose of the petition.',
  },
}

export default locale
